'use client';

import React, { useEffect, useState } from 'react';
import { Box, Grid, NoSsr, Typography } from '@mui/material';
import { PageWithLayoutType } from '../components/organisms/layouts';
import type { NextPage } from 'next';
import Image from 'next/image';
import Link from 'next/link';
import styled from 'styled-components';
import { Testimonials } from 'components/NewWebsite/Testimonials';
import { ContactUs } from 'components/NewWebsite/Contact';
import { ContainerMaxWidth, Layout } from 'components/organisms/layouts/Layout';
import { SubscribeInputBlock } from 'components/modules/Blog/SubscribeInput';
import { Trusted } from 'components/Trusted';
import { Partners } from 'components/Partners';
import { PartnersAndIntegrations } from 'components/PartnersAndIntegrations';
import { ProductTabs } from 'components/ProductTabs';
import { Metrics } from 'components/Metrics';
import { Barriers } from 'components/Barriers';
export const Colors = {
  CeruleanBlue: '#3547C5',
  RiverBed: '#44485A',
  LavenderMist: '#D6EAFF',
  Dark: '#1D202A',
  White: '#fff',
  Yellow: '#FFF290',
  AliceBlue: '#F2F8FF'
};
const METRICS2 = [{
  bgColor: '#3547C5',
  isWhite: true,
  metric: 'Affordability',
  description: 'Americans still find EV sticker prices to be too high'
}, {
  bgColor: '#C1E8D0',
  isWhite: false,
  metric: 'Range anxiety',
  description: 'The belief that EVs lack the range needed to reach standard destinations'
}, {
  bgColor: '#D6EAFF',
  isWhite: false,
  metric: 'Access to charging',
  description: 'People still do not fully understand how home and public charging work.'
}];
const StyledLink = styled(Link)`
  background-color: #3547c5;

  :hover {
    background-color: #4759cb;
  }
`;
export const METRICS = [{
  bgColor: Colors.White,
  metric: '55%',
  description: `EV badge users spent more than 10 seconds on the badge`
}, {
  bgColor: '#C1E8D0',
  metric: '+720k',
  description: `consumer and sales staff interactions with Lectrium EV dealer products`
}, {
  bgColor: '#D6EAFF',
  metric: '$7,714',
  description: `average undiscovered EV savings per 5-year ownership period!`
}];
export const MobilePadding = '30px';
export const DesktopPadding = '36px 76px 36px 76px';
export const DesktopPaddingLarger = '96px';
const Home: NextPage = () => {
  const [isPageLoaded, setIsPageLoaded] = useState(false); //this helps

  useEffect(() => {
    setIsPageLoaded(true);
  }, []);
  useEffect(() => {
    if (isPageLoaded) {
      if (window.location.hash === '#newsletter') {
        const ref = document.getElementById('newsletter');
        if (ref) {
          setTimeout(function () {
            ref.scrollIntoView({
              behavior: 'smooth',
              block: 'start'
            });
          }, 100);
        }
      }
    }
  }, [isPageLoaded]);
  return <NoSsr>
      <Box>
        <Box sx={{
        backgroundColor: Colors.AliceBlue,
        padding: {
          xs: MobilePadding,
          md: '40px 96px'
        }
      }}>
          <Box sx={{
          maxWidth: ContainerMaxWidth,
          mx: 'auto'
        }}>
            <Grid container>
              <Grid item xs={12} md={6} sx={{
              display: 'flex',
              alignItems: 'flex-start',
              flexDirection: 'column',
              justifyContent: 'center'
            }}>
                <Typography sx={{
                fontSize: '50px',
                color: Colors.Dark,
                fontWeight: 700,
                lineHeight: {
                  xs: 1,
                  md: 1.25
                }
              }}>
                  Automotive’s Favorite
                  <br />
                  EV Marketing Partner
                </Typography>
                <Typography sx={{
                color: '#44485A',
                fontSize: '16px',
                fontWeight: '400',
                mt: '24px'
              }}>
                  Your trusted merchandising partner for your EV inventory.
                </Typography>

                <Box sx={{
                my: '24px'
              }}>
                  <Box sx={{
                  display: 'flex',
                  alignItems: 'center'
                }}>
                    <Image src="/assets/images/check.svg" width={18} height={14} alt="Check Icon" />
                    <Typography sx={{
                    ml: '8px',
                    fontSize: '16px',
                    color: '#44485A'
                  }}>
                      Provide accurate EV data for every electric vehicle in your inventory.
                    </Typography>
                  </Box>
                  <Box sx={{
                  display: 'flex',
                  alignItems: 'center',
                  my: '8px'
                }}>
                    <Image src="/assets/images/check.svg" width={18} height={14} alt="Check Icon" />
                    <Typography sx={{
                    ml: '8px',
                    fontSize: '16px',
                    color: '#44485A'
                  }}>
                      Equip your sales team to confidently answer customer questions.
                    </Typography>
                  </Box>
                  <Box sx={{
                  display: 'flex',
                  alignItems: 'center'
                }}>
                    <Image src="/assets/images/check.svg" width={18} height={14} alt="Check Icon" />
                    <Typography sx={{
                    ml: '8px',
                    fontSize: '16px',
                    color: '#44485A'
                  }}>
                      Run a healthy EV business unit with quick inventory turns
                    </Typography>
                  </Box>
                </Box>

                <Box>
                  <StyledLink href={'/book-a-demo'} style={{
                  color: Colors.White,
                  fontWeight: 600,
                  padding: '12px 16px 12px 16px',
                  textTransform: 'none',
                  display: 'flex',
                  textAlign: 'center',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: '0.5rem',
                  maxWidth: '200px',
                  textDecoration: 'none',
                  fontFamily: 'Gilroy',
                  borderRadius: '2px'
                }}>
                    Book a demo
                    <Image src="/assets/svg/ArrowRight-white.svg" width={20} height={20} alt="" />
                  </StyledLink>
                </Box>
              </Grid>

              <Grid item xs={12} md={6} sx={{
              my: {
                xs: '2rem',
                md: ''
              }
            }}>
                <Image src="/assets/images/hero_image.png" width={600} height={600} quality={100} alt="" style={{
                width: '100%'
              }} />
              </Grid>
            </Grid>
          </Box>
        </Box>

        <Box sx={{
        mt: '24px'
      }}>
          <Partners />
        </Box>

        <Barriers />

        {/* <Box
          sx={{
            padding: { xs: MobilePadding, md: DesktopPaddingLarger },
            height: '100%',
            width: '100%',
          }}
         >
          <Box sx={{ maxWidth: ContainerMaxWidth, mx: 'auto' }}>
            <Typography
              sx={{
                fontSize: '32px',
                fontWeight: 700,
                textAlign: 'center',
                lineHeight: { xs: 1, md: 1.5 },
              }}
            >
              Dealers still face three major customer barriers to EV adoption
            </Typography>
            <Box
              sx={{
                display: 'flex',
                alignItems: 'normal',
                justifyContent: 'space-between',
                width: '100%',
                mt: '2rem',
                gap: '5%',
                flexDirection: { xs: 'column', md: 'row' },
              }}
            >
              {METRICS2.map((item, i) => (
                <Box
                  key={i}
                  sx={{
                    backgroundColor: item?.bgColor,
                    borderRadius: '2px',
                    padding: { xs: '30px', md: '40px' },
                    flex: '1', // Makes each box take equal space
                    display: 'flex',
                    justifyContent: 'center',
                    flexDirection: 'column',
                    alignItems: 'center',
                    gap: '1rem',
                  }}
                >
                  <Image
                    src={item?.isWhite ? '/assets/svg/zap-white.svg' : '/assets/images/zap.png'}
                    width={15}
                    height={15}
                    alt=""
                  />
                  <Typography
                    sx={{
                      fontSize: '32px',
                      fontWeight: 700,
                      textAlign: 'center',
                      color: item?.isWhite ? '#FFFFFF' : '#1D202A',
                    }}
                  >
                    {item?.metric}
                  </Typography>
                  <Typography
                    sx={{
                      color: item?.isWhite ? '#fff' : '#44485A',
                      textAlign: 'center',
                      fontSize: '14px',
                    }}
                  >
                    {item?.description}
                  </Typography>
                </Box>
              ))}
            </Box>
          </Box>
         </Box> */}

        <ProductTabs />

        <Metrics />

        <Trusted />

        <Testimonials />

        <PartnersAndIntegrations />

        {/* <PowerOfKnowledge /> */}

        <ContactUs />
        <SubscribeInputBlock />
      </Box>
    </NoSsr>;
};
(Home as PageWithLayoutType).layout = Layout;
export default Home;